import { useQuery } from 'react-query';

import { IPaging, IQueryParameters } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getCountries } from 'modules/settings/api';

interface IProps extends IPaging, IQueryParameters {}

export const useQueryCountries = ({ pageNo, pageSize, params }: IProps) =>
  useQuery(
    QUERY_KEYS.SETTINGS_PROFILE_CONTACT_COUNTRIES,
    () =>
      getCountries({
        pageNo,
        pageSize,
        params,
      }),
    {
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
    },
  );
